class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.close.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', '');
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    let firstElem = this.querySelector('.js-custom-active.mega_menu_custom_active');
    if (firstElem.querySelector('.js-inner-navigation')) {
      let outerContainer = firstElem.closest('.js-mega-menu-content').querySelector('.js-outer-navigation');
      if(outerContainer) outerContainer.classList.add('hidden');
    }

    // mega menu 
    this.addEventListener("mouseenter", () => {
        let activeElement = document.querySelector(".js-custom-active.mega_menu_custom_active");
        if (activeElement) {
            activeElement.classList.remove("mega_menu_custom_active");
        }
        document.querySelector(".js-custom-active").classList.add("mega_menu_custom_active");
    });

    let hoverElements = document.querySelectorAll(".js-custom-active");
    if (hoverElements.length > 0) {
        hoverElements.forEach(element => {
            element.addEventListener("mouseenter", () => {
                let activeElement = document.querySelector(".js-custom-active.mega_menu_custom_active");
                if (activeElement) {
                    activeElement.classList.remove("mega_menu_custom_active");
                    if(this.querySelector('.js-outer-navigation')) {
                      this.querySelector('.js-outer-navigation').classList.remove('hidden');
                    }
                }
                element.classList.add("mega_menu_custom_active");
                if(element.querySelector('.mega_menu_right_side')) {
                  let outerNav = element.closest('.js-mega-menu-content').querySelector('.js-outer-navigation');
                  if(outerNav) outerNav.classList.add('hidden'); 
                }
            });
        });
    } else {
        console.log("No elements found with the class .js-custom-active");
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
